/* eslint-disable */
import { lazy } from 'react';
import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';

const blog = lazy(() => import('views/blog/Blog'));
const community = {
  index: lazy(() => import('views/community/Community')),
  list: lazy(() => import('views/community/CommunityList')),
};
const upgrade = lazy(() => import('views/upgrade/Upgrade'));

const dashboard = {
  gettingStarted: lazy(() => import('views/dashboard/DashboardGettingStarted')),
  analysis: lazy(() => import('views/dashboard/DashboardAnalysis')),
};
const services = {
  database: lazy(() => import('views/services/ServicesDatabase')),
  databaseAdd: lazy(() => import('views/services/ServicesDatabaseAdd')),
  databaseDetail: lazy(() => import('views/services/ServicesDatabaseDetail')),
  storage: lazy(() => import('views/services/ServicesStorage')),
  storageFolder: lazy(() => import('views/services/ServicesStorageFolder')),
  hosting: lazy(() => import('views/services/ServicesHosting')),
  users: lazy(() => import('views/services/ServicesUsers')),
};
const account = {
  settings: lazy(() => import('views/account/AccountSettings')),
  settingsDetail: lazy(() => import('views/account/AccountSettingsDetail')),
  billing: lazy(() => import('views/account/AccountBilling')),
  billingDetail: lazy(() => import('views/account/AccountBillingDetail')),
};
const support = {
  docs: lazy(() => import('views/support/SupportDocs')),
  docsDetail: lazy(() => import('views/support/SupportDocsDetail')),
  knowledgeBase: lazy(() => import('views/support/SupportKnowledgeBase')),
  tickets: lazy(() => import('views/support/SupportTickets')),
  ticketsDetail: lazy(() => import('views/support/SupportTicketsDetail')),
};

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/home/start`,
    },
  ],
  sidebarItems: [
    {
      path: `${appRoot}/home`,
      label: ' ',
      icon: 'grid-1',
      exact: true,
      redirect: true,
      to: `${appRoot}/home/start`,
      subs: [
        { path: '/start', label: 'menu.getting-started', icon: 'navigate-diagonal', component: dashboard.gettingStarted },
        // { path: '/stats', label: 'menu.analysis', icon: 'chart-4', component: dashboard.analysis },
      ],
    },
    {
      path: `${appRoot}/sales`,
      label: 'menu.services',
      icon: 'grid-1',
      exact: true,
      redirect: true,
      to: `${appRoot}/sales/orders`,
      subs: [
        {
          path: '/orders',
          label: 'menu.database',
          icon: 'cart',
          component: services.database,
          subs: [
            { path: '/add', label: 'menu.database-add', hideInMenu: true, component: services.databaseAdd },
            { path: '/detail/:id', label: 'menu.database-detail', hideInMenu: true, component: services.databaseDetail },
          ],
        },
        // {
        //   path: '/invoices',
        //   label: 'menu.storage',
        //   icon: 'folder',
        //   component: services.storage,
        //   subs: [{ path: '/detail/:id', label: 'menu.storage', hideInMenu: true, component: services.storageFolder }],
        // },
        { path: '/payments/detail/:id', component: services.storageFolder, hideInMenu: true },
        { path: '/payments', label: 'menu.hosting', icon: 'quiz', component: services.hosting },
      ],
    },
    {
      path: `${appRoot}/catalogs`,
      label: 'menu.account',
      icon: 'user',
      exact: true,
      redirect: true,
      to: `${appRoot}/catalogs/customers`,
      subs: [
        { path: '/customers', label: 'menu.settings', icon: 'user', component: account.settings },
        { path: '/customer/detail/:id', label: 'menu.database-detail', hideInMenu: true, component: account.settingsDetail },
        { path: '/products', label: 'menu.billing', icon: 'shipping', component: account.billing },
        { path: '/product/detail/:id', label: 'menu.database-detail', hideInMenu: true, component: account.billingDetail },
      ],
    },
    {
      path: `${appRoot}/help`,
      label: 'menu.support',
      icon: 'help',
      exact: true,
      redirect: true,
      to: `${appRoot}/help/docs`,
      subs: [
        {
          path: '/solutions',
          label: 'menu.docs',
          icon: 'file-empty',
          component: support.docs,
          subs: [{ path: '/detail/:id', label: 'menu.docs', icon: 'file-empty', component: support.docsDetail, hideInMenu: true }],
        },
        { path: '/guides', label: 'menu.knowledge-base', icon: 'notebook-1', component: support.knowledgeBase },
        {
          path: '/support',
          label: 'menu.tickets',
          icon: 'bookmark',
          component: support.tickets,
          subs: [{ path: '/detail/:id', label: 'menu.tickets-detail', icon: 'file-empty', component: support.ticketsDetail, hideInMenu: true }],
        },
      ],
    },
  ],
};
export default routesAndMenuItems;
